import React from "react"
import { Helmet } from "react-helmet"
import { useLocation } from "@gatsbyjs/reach-router"
import parse from "html-react-parser"

export const SEO = ({ data }) => {
  const { title, tags, head, image } = data
  const location = useLocation()
  const currentPageUrl = location.pathname
  const normalisedTags = tags?.map(tag => {
    // convert Shopify and WP meta data to the same format
    return { key: tag.title_tag || tag.key, value: tag.content || tag.value }
  })

  let customTitle = title
  let customDesc = ""

  const locale = currentPageUrl.split("/")[1]
  const pathAfterLocale = currentPageUrl.replace(`/${locale}`, "")

  normalisedTags?.forEach(tag => {
    switch (tag.key) {
      case "title_tag":
        customTitle = tag.value
        break
      case "description_tag":
        customDesc = tag.value
        break
      case "description":
        customDesc = tag.value
        break
    }
  })

  if (head) {
    return (
      <Helmet>
        <html lang={process.env.HTML_LANG} />
        {head && parse(head)}
      </Helmet>
    )
  }

  return (
    <Helmet>
      {image && image.sourceUrl && (
        <meta property="og:image" content={image.sourceUrl} />
      )}
      <title>{customTitle}</title>
      <meta property="og:title" content={customTitle} />
      <link
        rel="alternate"
        href={`https://www.tennents.com/uk${pathAfterLocale}`}
        hrefLang="en-gb"
      />
      <link
        rel="alternate"
        href={`https://www.tennents.com/es${pathAfterLocale}`}
        hrefLang="es-es"
      />
      <link
        rel="alternate"
        href={`https://www.tennents.com/it${pathAfterLocale}`}
        hrefLang="it-it"
      />
      <link
        rel="alternate"
        href={`https://www.tennents.com/us${pathAfterLocale}`}
        hrefLang="en-us"
      />
      <link
        rel="alternate"
        href={`https://www.tennents.com/uk${pathAfterLocale}`}
        hrefLang="x-default"
      />
      {customDesc && <meta name="description" content={customDesc} />}
      {customDesc && <meta property="og:description" content={customDesc} />}
    </Helmet>
  )
}
